import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CommonService } from '../services/common.service';

@Component({
  selector: 'app-custom-locations',
  templateUrl: './custom-locations.component.html',
  styleUrls: ['./custom-locations.component.scss']
})
export class CustomLocationsComponent implements OnInit {

  postalCode
  locations = []
  selectedLocation
  markers = []
  previous
  show = false
  lat: number = 43.6532
  lng: number = -79.3832
  currentPage = 1
  lastPage
  constructor(private http : HttpClient, private common : CommonService) { }

  ngOnInit(): void {
  }

  setupMap(){
    // this.selectedLocation = this.locations[0]
    if(this.locations.length){
      this.locations.forEach((location,i) => {
        this.markers.push({
          lat : location.latitude,
          lng : location.longitude,
          draggable: false,
          label : i,
          title : location.location_name
        })
      });
      this.lat = +this.locations[0].latitude
      this.lng = +this.locations[0].longitude
    }
    else{
      this.show = true
    }
  }

  assignCoordinates(location:any){
    location = JSON.parse(location)
    // console.log(JSON.parse(location))
    let lat = location.latitude
    let lon = location.longitude
    this.markers = []
    this.selectedLocation = location
    this.lat = +lat
    this.lng =  +lon
    this.markers.push({
      lat : +location.latitude,
      lng : +location.longitude,
      draggable: false,
      // label : i,
      title : location.location_name
    })
  }

  clickedMarker(infowindow) {
    if (this.previous && this.markers.length>1) {
        this.previous.close();
    }
    this.previous = infowindow;
 }
  getLocationByPostal(){
    this.common.showLoader()
    this.getLocationByPostalCode(this.postalCode, 1).subscribe((res:any) => {
      this.locations = res.data.data
      this.show = false
      this.common.stopLoader()
      this.setupMap()
    }, err => {
      this.common.stopLoader()
      this.locations = []
      this.show = true
    })
  }



  getLocationByPostalCode(postal, page){
    this.locations = []
    this.markers = []
    return this.http.get(`${environment.api_link}/api/list-location?postal_code=${postal}&page=${page}`)
  }

  prevLocations(){
    if(this.currentPage != 1){
      this.common.showLoader()
      this.currentPage -= 1
      this.getLocationByPostalCode(this.postalCode, this.currentPage).subscribe((res:any) => {
        this.common.stopLoader()
        this.locations = res.data.data
        this.show = false
        this.lastPage = res.data.last_page
        this.setupMap()
      }, err => {
        this.common.stopLoader()
        this.locations = []
        this.show = true
      })
    }
    
  }

  nextLocations(){
    if(this.currentPage != this.lastPage){
      this.common.showLoader()
      this.currentPage += 1
      this.getLocationByPostalCode(this.postalCode, this.currentPage).subscribe((res:any) => {
        this.common.stopLoader()
        this.locations = res.data.data
        this.show = false
        this.lastPage = res.data.last_page
        this.setupMap()
      }, err => {
        this.common.stopLoader()
        this.locations = []
        this.show = true
      })
    }
  }
}
